module.exports = __webpack_public_path__ + "media/images/pages/hazard/bg_area_04-03fd622d18735f3f5f19c4550d329ec2.png";